import moment from "moment-timezone";
import { FETCH_YOUTUBE_PAGE_LIST, FETCH_YT_METRICS, SET_YOUTUBE_SELECTED_PAGE, UPDATE_YOUTUBE_DURATION_FILTER } from "../actions/youtubeInsightsActions";
import { sortInstaPages } from "../actions/insightsActionUtils";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { formatYTData } from "../actions/youtubeActionUtils";

const initialState = {
    pagesListLoading: false,
    pagesList: [],
    chartData: {},
    chartDataLoading: {},
    chartLoadingFailed: {},
    selectedYoutubePage: [],
    durationFilter: {
        duration: "7",
        startDateTime: moment(new Date()).subtract(6, "days").startOf("day").format("YYYY-MM-DD"),
        endDateTime: moment(new Date()).format("YYYY-MM-DD"),
    },
    // followersCountByFacets: {
    //     pageId: null,
    //     chartIsLoading: false,
    //     chartLoadingFailed: false,
    //     data: {},
    // },
    // pageInfo: 0,
    // followerChartLoading: false,
};
const youtubeInsightsReducers = (state = initialState, action) => {
    switch (action.type) {
        case isPending(FETCH_YOUTUBE_PAGE_LIST):
            return (state = {
                ...state,
                pagesListLoading: true,
            });

        case isRejected(FETCH_YOUTUBE_PAGE_LIST):
            return (state = {
                ...state,
                pagesListLoading: false,
            });

        case isFulfilled(FETCH_YOUTUBE_PAGE_LIST):
            return (state = {
                ...state,
                pagesListLoading: false,
                pagesList: sortInstaPages(action.payload) || [],
            });

        case SET_YOUTUBE_SELECTED_PAGE:
            return (state = {
                ...state,
                selectedYoutubePage: action.payload,
            });

        case UPDATE_YOUTUBE_DURATION_FILTER:
            return (state = {
                ...state,
                durationFilter: { ...state.filterDuration, ...action.payload },
            });
        case isPending(FETCH_YT_METRICS):
            return (state = {
                ...state,
                chartDataLoading: { ...state.chartDataLoading, [action.payload.chart_name]: true },
            });

        case isFulfilled(FETCH_YT_METRICS):
            return (state = {
                ...state,
                chartData: { ...state.chartData, [action.payload.chart_name]: formatYTData(action.payload) },
                chartDataLoading: { ...state.chartDataLoading, [action.payload.chart_name]: false },
            });

        case isRejected(FETCH_YT_METRICS):
            return (state = {
                ...state,
                chartLoadingFailed: { ...state.chartLoadingFailed, [action.payload.chart_name]: true },
                chartDataLoading: { ...state.chartDataLoading, [action.payload.chart_name]: false },
            });

        // case isPending(FETCH_LK_FOLLOWERS_BY_FACET):
        //     return (state = {
        //         ...state,
        //         followersCountByFacets: {
        //             ...state.followersCountByFacets,
        //             chartIsLoading: true,
        //             chartLoadingFailed: false,
        //             pageId: action.payload.pageId,
        //         },
        //     });
        // case isFulfilled(FETCH_LK_FOLLOWERS_BY_FACET):
        //     return (state = {
        //         ...state,
        //         followersCountByFacets: {
        //             ...state.followersCountByFacets,
        //             chartIsLoading: false,
        //             chartLoadingFailed: false,
        //             data: formatTkData(action.payload),
        //         },
        //     });
        // case isRejected(FETCH_LK_FOLLOWERS_BY_FACET):
        //     return (state = {
        //         ...state,
        //         followersCountByFacets: {
        //             ...state.followersCountByFacets,
        //             chartIsLoading: false,
        //             chartLoadingFailed: true,
        //         },
        //     });

        default:
            return state;
    }
};
export default youtubeInsightsReducers;
